<template>
  <section class="row">
    <div class="col-12 col-md-9 mx-auto">
      <v-input
        input-id="local-content"
        label="Valeur des biens"
        sublabel="(mobilier, matériel informatique, équipements...)"
        error-message="La valeur des biens doit être inférieure ou égale à 1 000 000 €"
        mask="currency"
        module-name="contract"
        getter-name="get"
        setter-name="updateSubscription"
        :getter-function="getContent"
        :input-validation="validateMrpContent"
        path="risk.local.content"
        placeholder="10 000"
      />
    </div>
  </section>
</template>
<script>
import { get } from 'lodash-es';
import { validateMrpContent } from '@/utils/validators';

import Input2 from '@/components/common/input/Input2.vue';

export default {
  name: 'ReportedRevenue',
  components: {
    'v-input': Input2,
  },
  methods: {
    validateMrpContent,
    getContent(contract) {
      return get(contract, 'risk.local.content', null);
    },
  },
};
</script>
